import React from 'react';
import { translate } from 'react-i18next';

import TimeSheetNav from 'components/timesheets/TimeSheetNav.js';
import TimeSheetPreview from 'components/timesheets/TimeSheetPreview.js';
import PreviousTimeSheetPreview from 'components/timesheets/PreviousTimeSheetPreview';

import StatusDialogs from 'components/StatusDialogs.js';
import TimeSheetActions from 'actions/TimeSheetActions.js';

class TimeSheetsView extends React.Component {
  constructor(props) {
    super(props);
    this._onClickHandler = this._onClickHandler.bind(this);
    this._onTimeSheetDataLoaded = this._onTimeSheetDataLoaded.bind(this);
    this._onTimeSheetDataError = this._onTimeSheetDataError.bind(this);
    this._onTimeSheetPunchesApproved = this._onTimeSheetPunchesApproved.bind(this);
    this._onTimeSheetApprovalError = this._onTimeSheetApprovalError.bind(this);
    this.state = {
      activePage: 'currentTimeSheet',
      currentTimeSheet: null,
      previousTimeSheet: null,
      currentLocation: null,
      statuses: [],
      noTimesheets: null,
      lockActivePage: false,
    };
  }

  componentDidMount() {
    TimeSheetStore.on('timesheet:load:success', this._onTimeSheetDataLoaded);
    TimeSheetStore.on('timesheet:load:error', this._onTimeSheetDataError);
    TimeSheetStore.on('timesheet:approve:success', this._onTimeSheetPunchesApproved);
    TimeSheetStore.on('timesheet:approve:error', this._onTimeSheetApprovalError);
    TimeSheetActions.getTimeSheets();

    if (Utils.isOnline()) Utils.enableGlobalSpinner();
  }

  componentWillUnmount() {
    TimeSheetStore.off('timesheet:load:success', this._onTimeSheetDataLoaded);
    TimeSheetStore.off('timesheet:load:error', this._onTimeSheetDataError);
    TimeSheetStore.off('timesheet:approve:success', this._onTimeSheetPunchesApproved);
    TimeSheetStore.off('timesheet:approve:error', this._onTimeSheetApprovalError);
    this.state.activePage = null;
  }

  _onTimeSheetDataLoaded(response) {
    // check if the user actually has any timesheet data, if not display no
    // data message.
    if (!_.isEmpty(response.locations)) {
      const curDate = moment(Utils.getCurrentDate());
      let currentLocationData;
      let activePageString;
      let currentData;
      let previousData;

      // check if the lockActive state is set and not refresh to the default
      // location. Defaulting to the first section is really only for the
      // initial load.
      if (this.state.lockActivePage) {
        currentLocationData = this.state.currentLocation;
        activePageString = this.state.activePage;
        currentData = TimeSheetStore.getCurrentTimeSheet(currentLocationData.id);
        previousData = TimeSheetStore.getPreviousTimeSheets(currentLocationData.id);
      } else {
        currentLocationData = response.locations[0];
        currentData = TimeSheetStore.getCurrentTimeSheet(response.locations[0].id);
        previousData = TimeSheetStore.getPreviousTimeSheets(response.locations[0].id);
        activePageString = currentData != null ? 'currentTimeSheet' : 'previousTimeSheet';
      }

      this.setState({
        currentTimeSheet: currentData,
        previousTimeSheet: previousData,
        activePage: activePageString,
        locations: response.locations,
        user: response.user,
        punches: response.punches,
        breakPunches: response.breakPunches,
        currentLocation: currentLocationData,
      });
    } else {
      this.setState({
        noTimesheets: true,
      });
    }

    Utils.removeSpinner();
  }

  _onTimeSheetDataError(error) {
    this.state.statuses.push({
      title: this.props.t('TimeSheetsView.error'),
      message: this.props.t('TimeSheetsView.retrieval_error'),
      status: 'error',
      key: _.uniqueId(),
    });
    this.setState({
      statuses: this.state.statuses,
    });

    Utils.removeSpinner();
  }

  _onClickHandler(currentButton) {
    this.setState({
      activePage: currentButton,
      statuses: [],
    });
    this.props.activePage = currentButton;
  }

  _changeLocation(id) {
    const currentData = TimeSheetStore.getCurrentTimeSheet(id);
    this.setState({
      currentTimeSheet: currentData,
      previousTimeSheet: TimeSheetStore.getPreviousTimeSheets(id),
      currentLocation: TimeSheetStore.getLocationById(id),
      activePage: currentData != null ? 'currentTimeSheet' : 'previousTimeSheet',
    });
  }

  _approvePunches(punches) {
    if (punches) {
      TimeSheetActions.approvePunches(punches);
    }
  }

  _onTimeSheetPunchesApproved(response) {
    TimeSheetActions.getTimeSheets();

    this.state.statuses.push({
      title: this.props.t('TimeSheetsView.success'),
      message: this.props.t('TimeSheetsView.approval_success'),
      status: 'success',
      key: _.uniqueId(),
    });
    this.setState({
      statuses: this.state.statuses,
    });

    this.state.lockActivePage = true;
    TimeSheetActions.getTimeSheets();
    Utils.enableGlobalSpinner();
  }

  _onTimeSheetApprovalError(error) {
    this.state.statuses.push({
      title: this.props.t('TimeSheetsView.error'),
      message: this.props.t('TimeSheetsView.approval_error'),
      status: 'error',
      key: _.uniqueId(),
    });
    this.setState({
      statuses: this.state.statuses,
    });
  }

  _closeStatusDialog(props) {
    let count = 0;
    const idx = this.state.statuses.map((status) => {
      if (props.status.key == status.key) {
        return count;
      }
      count++;
    });
    if (idx) this.state.statuses.splice(idx, 1);

    this.setState({
      statuses: this.state.statuses,
    });
  }

  render() {

    if (
      this.state.currentTimeSheet == null
      && this.state.previousTimeSheet == null
      && this.state.noTimesheets == null
    ) {
      return false;
    }

    let timesheetClass = '';
    let noTimeSheetClass = 'hide';
    if (this.state.noTimesheets) {
      timesheetClass = 'hide';
      noTimeSheetClass = '';
    }

    return (
      <div>
        <section id="timesheet" className={timesheetClass}>
          <aside>
            <TimeSheetNav
              currentSheet={this.state.currentTimeSheet}
              previousSheets={this.state.previousTimeSheet}
              displayBreakPunches={this.props.breakPunchesEnabled}
              activePage={this.state.activePage}
              onClickHandler={this._onClickHandler.bind(this)}
            />
          </aside>
          <main>
            <TimeSheetPreview
              shouldRender={this.state.currentTimeSheet != null}
              type="current"
              showHeader
              data={this.state.currentTimeSheet}
              activeState={this.state.activePage == 'currentTimeSheet' ? 'active' : 'hidden'}
              user={this.state.user || {}}
              punches={this.state.punches || {}}
              breakPunches={this.state.breakPunches || {}}
              locations={this.state.locations || {}}
              currentLocation={this.state.currentLocation || {}}
              onLocationChange={this._changeLocation.bind(this)}
              onApprovePunches={this._approvePunches.bind(this)}
            />
            <PreviousTimeSheetPreview
              shouldRender={this.state.previousTimeSheet != null}
              type="previous"
              data={this.state.previousTimeSheet}
              activeState={this.state.activePage == 'previousTimeSheet' ? 'active' : 'hidden'}
              user={this.state.user || {}}
              punches={this.state.punches || {}}
              breakPunches={this.state.breakPunches || {}}
              locations={this.state.locations || {}}
              currentLocation={this.state.currentLocation || {}}
              onLocationChange={this._changeLocation.bind(this)}
              onApprovePunches={this._approvePunches.bind(this)}
            />
            <StatusDialogs statuses={this.state.statuses} onClose={this._closeStatusDialog.bind(this)} />
          </main>
        </section>
        <section id="no-timesheets" className={noTimeSheetClass}>
          <img src="/images/Timesheet_Icon.svg" id="no-timesheet-icon" />
          <h1>{this.props.t('TimeSheetsView.no_timesheets_to_view')}</h1>
          <p>{this.props.t('TimeSheetsView.check_back_later')}</p>
        </section>
      </div>
    );
  }
}

export default translate()(TimeSheetsView);
